import PropTypes from 'prop-types';
import React from 'react';
import Button from '../../ui/Button';
import ModalTrigger from '../../ui/ModalTrigger';

/**
 * ModalTrigger wrapper to be used in functional components. Renders a Button that when clicked,
 * will open an instance of the specified modal class.
 *
 * example:
 *
 * const someComponent({})=>{
 *
 *   return {
 *     ...
 *
 *     <ModalTriggerButton
 *        onClick={()=>{analytics.track({"modal trigger was clicked"})}
 *        text="Click for a modal!"
 *        className="my-cool-button"
 *        appearance="text-light"
 *        size="small"
 *        modalClass={MyModalClass}
 *     />
 *    ...
 *   }
 * }
 *
 * @param onClick: Function to call before opening the modal.
 * @param modalClass The class of modal that will be shown. A modal class is an react element that
 * @buttonProps Extra props that will be passed into the rendered button, see props for Button.
 * renders a <Modal> element. This class will be instanced and rendered by the button when clicked.
 */
const ModalTriggerButton = ({ onClick, modalClass: ModalClass, ...buttonProps }) => (
  <ModalTrigger
    renderTrigger={open => (
      <Button
        {...buttonProps}
        onClick={() => {
          if (typeof onClick === 'function') {
            onClick();
          }
          open();
        }}
      />
    )}
    renderModal={onClose => new ModalClass({ onClose })}
  />
);

ModalTriggerButton.propTypes = {
  onClick: PropTypes.func,
  modalClass: PropTypes.elementType.isRequired,
  text: PropTypes.string,
  className: PropTypes.string,
  appearance: PropTypes.string,
  size: PropTypes.string,
};

ModalTriggerButton.defaultProps = {
  text: 'Learn More',
  className: 'confirm taller-button chill-button',
  appearance: 'text-light',
  size: 'small',
  onClick: undefined,
};

export default ModalTriggerButton;
